import {User} from '../models/user.model';

const SUFFIX = /[?#]/;
const PATH_INDEX = 0;
const HEAD_ROLE = 'ROLE_HEAD';
const ROLE_MISSING = -1;
const EMPTY_PATH = '';
const COMMON_ROUTES = [
  /^\/dashboard\/?$/, /^\/dashboard\/home\/?$/, /^\/dashboard\/(testing|biometry|standards|operating-standard|profile)\/?$/,
  /^\/dashboard\/standard\/[^/]+(?:\/blanks)?\/?$/, /^\/dashboard\/profile\/[^/]+\/?$/,
  /^\/dashboard\/(standard-discussion|familiarize-standard|confirm-standard)\/[^/]+\/?$/
];
const HEAD_ROUTES = [
  /^\/dashboard\/groups(?:\/[^/]+)?\/?$/,
  /^\/dashboard\/company-structure(?:-user)?\/?$/,
  /^\/dashboard\/create-suggestion-list\/[^/]+\/?$/,
  /^\/dashboard\/my-suggestion-lists(?:\/my-lists|\/my-drafts)?\/?$/,
  /^\/dashboard\/suggestion-list-details\/[^/]+\/?$/
];

export function isPwaHead(user: User): boolean {
  return !!user && !!user.roles && user.roles.indexOf(HEAD_ROLE) !== ROLE_MISSING;
}

export function isPwaDashboardRouteAllowed(url: string, user: User): boolean {
  const path = (url || EMPTY_PATH).split(SUFFIX)[PATH_INDEX];
  return COMMON_ROUTES.some(route => route.test(path)) || (isPwaHead(user) && HEAD_ROUTES.some(route => route.test(path)));
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-route-policy.ts